enum Network {
  Mainnet = "mainnet-beta",
  Testnet = "testnet",
  Devnet = "devnet",
}

export default Network;
